module.exports = __webpack_public_path__ + "static/img/bg2.ede2098.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/bg2.jpg
// module id = pNAw
// module chunks = 4